export default {
  SET_MAIL_TEMPLATE: function (state, payload) {
    state.mailTemplates = payload;
  }
}
